// extracted by mini-css-extract-plugin
module.exports = {"saveChangesButton":"styles_saveChangesButton__W8Prg"};